import { rubyIdentModule } from "@/modules/ruby-ident.module";

export default function getRequestHeaders() {
    let headers = {
        'Content-Type': 'application/json',
    };

    if (rubyIdentModule.state.user && rubyIdentModule.state.user.token) {
        headers['Authorization'] = 'Bearer ' + rubyIdentModule.state.user.token;
    }

    return headers;
}